import { createAction } from '../utils';
export var LOAD_PROCESSES = '[BPMN] load processes';
export var LOAD_PROCESSES_SUCCESS = '[BPMN] load processes success';
export var LOAD_PROCESSES_ERROR = '[BPMN] load processes error';
export var START_PROCESS_BY_ID = '[BPMN] start process by id';
export var START_PROCESS_BY_ID_SUCCESS = '[BPMN] start process by id success';
export var START_PROCESS_BY_ID_ERROR = '[BPMN] start process by id error';
export var START_PROCESS_BY_KEY = '[BPMN] start process by key';
export var START_PROCESS_BY_KEY_SUCCESS = '[BPMN] start process by key success';
export var START_PROCESS_BY_KEY_ERROR = '[BPMN] start process by key error';
export var START_PROCESS_BY_APP = '[BPMN] start process by app';
export var START_PROCESS_BY_APP_SUCCESS = '[BPMN] start process by app success';
export var START_PROCESS_BY_APP_ERROR = '[BPMN] start process by app error';
// BPMN processes
export var fetchProcessesAction = function (payload) { return createAction(LOAD_PROCESSES, payload); };
export var fetchProcessesSuccessAction = function (payload) {
    return createAction(LOAD_PROCESSES_SUCCESS, payload);
};
export var fetchProcessesErrorAction = function (payload) { return createAction(LOAD_PROCESSES_ERROR, payload); };
// BPMN process by processDefinitionId
export var startProcessByIdAction = function (payload) {
    return createAction(START_PROCESS_BY_ID, payload);
};
export var startProcessByIdSuccessAction = function () { return createAction(START_PROCESS_BY_ID_SUCCESS, null); };
export var startProcessByIdErrorAction = function (payload) {
    return createAction(START_PROCESS_BY_ID_ERROR, payload);
};
// BPMN process by processDefinitionKey
export var startProcessByKeyAction = function (payload) { return createAction(START_PROCESS_BY_KEY, payload); };
export var startProcessByKeySuccessAction = function () { return createAction(START_PROCESS_BY_KEY_SUCCESS, null); };
export var startProcessByKeyErrorAction = function (payload) {
    return createAction(START_PROCESS_BY_KEY_ERROR, payload);
};
// BPMN process by application properties
export var startProcessByAppAction = function (payload) { return createAction(START_PROCESS_BY_APP, payload); };
export var startProcessByAppSuccessAction = function () { return createAction(START_PROCESS_BY_APP_SUCCESS, null); };
export var startProcessByAppErrorAction = function (payload) {
    return createAction(START_PROCESS_BY_APP_ERROR, payload);
};
//# sourceMappingURL=actions.js.map